module.exports = __webpack_public_path__ + "img/attachment.2e893edf.svg";